import { Component, Input, ViewEncapsulation } from '@angular/core';
import { PlIcon } from '@app/icon-library/icons';
import { NgOnInitWriteBugAbstractComponent } from '@shared/abstract/ngOnInitWriteBug.abstract.component';
import { ControlValueAccessor } from '@angular/forms';

export enum ProgressBarHeight {
  large = 'large',
  small = 'small',
}

export enum SliderColor {
  orange = 'orange',
  gray = 'gray',
}

@Component({
  selector: 'pl-slider',
  templateUrl: './pl-slider.component.html',
  styleUrls: ['./pl-slider.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PlSliderComponent extends NgOnInitWriteBugAbstractComponent<number> implements ControlValueAccessor {
  @Input() public min: number = 0;
  @Input() public max: number = 100;
  @Input() public step: number = 1;
  @Input() public isDisabled: boolean = false;
  @Input() public showTicks: boolean = false;
  @Input() public progressBarHeight: ProgressBarHeight = ProgressBarHeight.small;
  @Input() public handleColor: SliderColor = SliderColor.orange;
  @Input() public inactiveTrackColor: SliderColor = SliderColor.gray;

  public value: number = 0;

  protected readonly SliderColor: typeof SliderColor = SliderColor;
  protected readonly ProgressBarHeight: typeof ProgressBarHeight = ProgressBarHeight;
  protected readonly PlIcon: typeof PlIcon = PlIcon;

  public plOnInit(): void | Promise<void> {}

  public plWriteValue(value: number): void {
    this.value = value;
  }

  public onSliderChange(): void {
    this.onTouchedCallback();
    this.onChangeCallback(this.value);
  }
}
